document.addEventListener("DOMContentLoaded", () => {
  render_min_guarantees_table();
});

const render_min_guarantees_table = () => {
  $("#min-guarantees-table").DataTable({
    fixedHeader: true,
    processing: true,
    serverSide: true,
    destroy: true,
    ajax: {
      type: "get",
      url: "/minimum_guarantees",
      dataType: "json",
      data: (data) => {
        const table = $("#min-guarantees-table").DataTable();
        data.page = parseInt(table.page.info().page) + 1;
        data.per_page = table.page.info().length;
        data.search = data.search.value;
        data.order = table.order()[0][0];
        data.direction = table.order()[0][1];
        data.statuses = $("#select-guarantee-status").val();
        data.types = $("#select-guarantee-type").val();
        data.employee_id = $("#min-guarantees-table").data("employee_id");
      },
    },
    columnDefs: [
      {
        bSortable: false,
        aTargets: [1, 2, 9],
      },
    ],
  });
  debounceSearch("#min-guarantees-table");
};

$(document).on(
  "change",
  "#select-guarantee-type, #select-guarantee-status",
  function () {
    $("#min-guarantees-table").DataTable().ajax.reload();
  }
);

const loadMinimumGuaranteeModal = (url, data = {}) => {
  if (!url) return;

  $.ajax({
    type: "get",
    url,
    data,
    dataType: "json",
    success: ({ html }) => {
      const container = $("#minimum-guarantee-modal-container");
      container.html(html);
      container.find(".modal").modal("show");
      select2_avatar_options();
    },
  });
};

$(document).on("click", "#add-min-guarantee-btn", function () {
  const employeeId = $("#min-guarantees-table").data("employee_id");
  const data = employeeId ? { employee_id: employeeId } : {};

  loadMinimumGuaranteeModal($(this).data("url"), data);
});

$(document).on("hidden.bs.modal", "#minimum-guarantee-modal-container .modal", function () {
  $("#minimum-guarantee-modal-container").empty();
});

$(document).on("click", ".edit-min-guarantee-btn, .show-min-guarantee-history-btn", function () {
  loadMinimumGuaranteeModal($(this).data("url"));
});

$(document).on("submit", "#download-min-guarantees-form", function (e) {
  e.preventDefault();

  let types = $("#select-guarantee-type").val();
  let statuses = $("#select-guarantee-status").val();
  let search = $("#min-guarantees-table_filter input").val();
  let startDate = $(this).find("input[name='start_date']").val();
  let endDate = $(this).find("input[name='end_date']").val();

  let baseUrl = "/minimum_guarantees.csv";
  let query = $.param({
    types: types,
    statuses: statuses,
    search: search,
    start_date: startDate,
    end_date: endDate
  });

  window.location.href = baseUrl + "?" + query;
  $("#download-min-guarantee-csv").modal("hide");
});

$(document).on("ajax:success", "#import-minimum-guarantees-from-csv", function (e) {
  const { success } = e.detail[0] || {};
  const errorDiv = $("#minimum-guarantees-import-errors");

  errorDiv.addClass("d-none").html("");
  $("#import-min-guarantee-csv").modal("hide");
  this.reset();
  $("#minimum_guarantees_csv").siblings(".custom-file-label").html("Choose file");

  if ($("#min-guarantees-table").length) {
    $("#min-guarantees-table").DataTable().ajax.reload();
  }

  if (success) {
    const html = `<div class='alert alert-success w-100'><h6>${success}</h6></div>`;
    $(".alert-container").html(html);
    show_alert_container();
  }
});

$(document).on("ajax:error", "#import-minimum-guarantees-from-csv", function (e) {
  const errorDiv = $("#minimum-guarantees-import-errors");
  const payload = (e.detail && e.detail[0]) || {};
  const xhr = e.detail && e.detail[2];
  const errors = payload.errors || (xhr && xhr.responseJSON && xhr.responseJSON.errors) || [];
  const normalizedErrors = Array.isArray(errors) ? errors : [errors].filter(Boolean);
  const displayErrors = normalizedErrors.length ? normalizedErrors : ["Something went wrong. Please try again."];
  const header = "<p class='text-danger px-4 pt-3'><strong>Import failed:</strong></p>";

  append_errors_inside_modal(displayErrors, header, errorDiv);
});

$(document).on("change", "#minimum_guarantees_csv", function () {
  const fileName = $(this).val().split("\\").pop();
  $(this).siblings(".custom-file-label").html(fileName || "Choose file");
});
